export const PROVINCES_LOADING = "PROVINCES_LOADING";
export const GET_PROVINCES_SUCCESS = "GET_PROVINCES_SUCCESS";
export const GET_PROVINCES_FAILURE = "GET_PROVINCES_FAILURE";
